import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  paper: {
    width: 500,
  },
}));

export default useStyles;
